import React from 'react';
import { LoadingScreen } from '../../components/shared/LoadingScreen/LoadingScreen';
import { useSelector } from 'react-redux';
import { selectDependencyApps, selectDependencyTools, selectParentApp } from '../hmi/hmiSlice';

type Props = {
  children: React.ReactNode;
};

export const SignupApplicationHandler: React.FC<Props> = ({ children }) => {
  const parentApp = useSelector(selectParentApp);
  const dependencyApps = useSelector(selectDependencyApps);
  const dependencyTools = useSelector(selectDependencyTools);

  if (
    !parentApp ||
    (parentApp.setup.dependencies && parentApp.setup.dependencies?.length !== dependencyApps.length) ||
    (parentApp.dependencies && parentApp.dependencies.tools.length !== dependencyTools.length)
  ) {
    return <LoadingScreen messageId={'hatters.signup.loading'} />;
  }

  return <>{children}</>;
};
